module.exports = __webpack_public_path__ + "static/media/caixa-saude.4b50ef54.jpg";